import { render } from "./PrivacyPolicy.vue?vue&type=template&id=2e6e401a&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=2e6e401a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6e401a"]])

export default __exports__